import produce from 'immer';
import { GEM_SOCKET_UPDATE_LOG_LIST_REQUEST } from '../../constants/log/gemSocketUpdateLogConstants';

const initialState = {

};

const gemSocketUpdateLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case GEM_SOCKET_UPDATE_LOG_LIST_REQUEST:
      break;
    default:
      break;
  }
});

export default gemSocketUpdateLogReducer;
